/**
 * Created by luka on 01.03.2018.
 */
import { push, goBack } from 'react-router-redux'

export function resetNavigationToOverview() {
    return push('/');
}
export function navigationToMilestone({type}) {
    return push('/milestone', {
        type
    });
}

export function resetNavigationToLevel() {
    return push('/level');
}

export function navigationToWorkout() {
    return push('/workout');
}
export function navigationToWorkoutPreview() {
    return push('/workoutPreview');
}

export function navigationToFriends() {
    return push('/friends');
}

export function navigationToRating(day) {
    return push(`/rating/${day}`);
}

export function navigationToSuccess() {
    return push('/success');
}

export function navigationToInvite() {
    return push('/invite');
}

export function navigationToConnect() {
    return push('/connect');
}

export function navigationToSurvey() {
    return push('/survey');
}

export function navigationToDisabled() {
    return push('/disabled');
}

export function navigationToPayout() {
    return push('/payout');
}

export function navigationToPayoutSuccess() {
    return push('/payoutSuccess');
}

export function navigationToPause() {
    return push('/pause');
}

export function navigationToInfo() {
    return push('/info');
}

export function navigationToWallet() {
    return push('/wallet');
}

export function navigationToFeedback() {
    return push('/feedback');
}

export function navigationToReorder() {
    return push('/reorder');
}

export function navigationBack() {
    return goBack();
}


// WEBPACK FOOTER //
// ./src/navigation/NavigationActions.js